import React, { Component } from 'react';
import { Link, browserHistory } from 'react-router';
import moment from 'moment';
import _ from 'lodash';
import Select2 from 'react-select2-wrapper';
import withNotify from '../../common/withNotify';
import withLoader from '../../common/withLoader';
import Header from '../../components/Header';
import withGoBack from '../../common/withGoBack';
import withUser from '../../common/withUser';
import withInventoryFilter from '../../common/withInventoryFilter';
import { onGoBack } from '../../common/globals';
import Bugsnag from '../../helpers/bugsnag';
import {
  getAccountName,
  getInventory,
  getInventoryByAccountName
} from '../../utils/db';
import ViewInventoryScanSession from '../../components/Inventory/ViewInventoryScanSession';
import NoScanSession from '../../components/Models/NoScanSession';
import OptimizeDatePicker from '../../components/commonComponents/OptimizeDatePicker';

class ViewInventory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: new Date(),
      expiringDay: 0,
      account: {},
      accountName: '',
      scanSessionData: {},
      isSessionList: false,
      selectedScanSession: '',
      selectedSession: [],
      orderData: [],
      selectedOrderBy: 'PRODUCT #',
      varianceSettingsData: [
        {
          id: 0,
          value: 'NONE'
        },
        {
          id: 1,
          value: 'PRODUCT'
        },
        {
          id: 2,
          value: 'LOT'
        },
      ],
      selectedVariance: 'NONE',
      inventoryComparisonData: [
        {
          id: 0,
          value: 'CONSIGNMENT vs SCANS (S-C)'
        },
        {
          id: 1,
          value: 'PAR vs CONSIGNMENT (C-P)'
        },
        {
          id: 2,
          value: 'PAR vs SCANS (S-P)'
        }
      ],
      selectedInventoryComparison: ['CONSIGNMENT vs SCANS (S-C)'],
      searchProduct: [],
      searchProductDesc: [],
      searchLotNo: [],
      isScanOnly: false,
      isExpire: false,
      isChecked: true
    };
    this.noScanSession = null;
  }

  componentDidMount() {
    document.getElementById('expireDate').setAttribute('readonly', 'readonly');
    this.noScanSession = new window.bootstrap.Modal(window.$('#noScanSessionModal'));
  }

  _onApplyFilter = () => {
    try {
      this._onGoBack();
      browserHistory.push('/inventory/consignment/view-inventory/session-filter');
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onGetScanSessionList = () => {
    try {
      const { scanSessionData, isSessionList } = this.state;
      if (Object.keys(scanSessionData).length > 0) {
        this.setState({ scanSessionData, isSessionList: !isSessionList });
      } else {
        this.noScanSession.show();
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _goBack = () => {
    try {
      const { goBack, setInventoryFilter } = this.props;
      onGoBack(goBack);
      setInventoryFilter({});
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onChangeDate = (value) => {
    try {
      const { inventoryFilter, setInventoryFilter } = this.props;
      const { isExpire } = this.state;
      const a = moment(value);
      const b = moment();
      this.setState({
        expiringDay: moment().format('M/DD/yy') === moment(value).format('M/DD/yy')
          ? 0
          : a.diff(b, 'days') + 1,
        startDate: value
      });
      if (isExpire) {
        setInventoryFilter({
          ...inventoryFilter,
          ExpireDate: [moment(value).format('M/DD/yy')],
          ExpiringDay: [moment().format('M/DD/yy') === moment(value).format('M/DD/yy')
            ? 0
            : a.diff(b, 'days') + 1],
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onChangeDay = (e) => {
    try {
      const { inventoryFilter, setInventoryFilter } = this.props;
      const { isExpire } = this.state;
      const newDate = moment(new Date()).add(e.target.value, 'days');
      this.setState({
        expiringDay: e.target.value,
        startDate: e.target.value !== '' ? new Date(newDate) : new Date()
      });
      if (isExpire) {
        setInventoryFilter({
          ...inventoryFilter,
          ExpiringDay: [e.target.value],
          ExpireDate: [e.target.value !== '' ? moment(new Date(newDate)).format('M/DD/yy') : moment(new Date()).format('M/DD/yy')],
        });
      }
    } catch (er) {
      Bugsnag.notify(er);
    }
  }

  _onGoBack = () => {
    try {
      const { goBack, setGoBack } = this.props;
      goBack.push(window.location.pathname);
      setGoBack(goBack);
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onGetAccountName = async () => {
    try {
      const { setLoader } = this.props;
      const accountNameRes = await getAccountName();
      const inventoryRes = await getInventory();
      inventoryRes.map((value) => {
        value.InventoryType = value.ProductEnterType;
      });
      const mergeInventoryAndInventoryScan = accountNameRes.concat(inventoryRes);
      setLoader(true);
      const groupedData = _.groupBy(mergeInventoryAndInventoryScan, 'AccountName');
      let inventoryScan = {};
      Object.keys(groupedData).map(async (data) => {
        let par = 0; let congin = 0; let
          scan = 0;
        groupedData[data].map((item) => {
          if (item.InventoryType === 'PAR') {
            par += 1;
          } else if (item.InventoryType === 'CONSIGN') {
            congin += 1;
          } else if (item.InventoryType === 'SCAN' || item.InventoryType === 'MANUAL' || item.InventoryType === 'EXTDEVICE') {
            scan += 1;
          }
        });
        inventoryScan = Object.assign(
          inventoryScan,
          {
            [data]: {
              PAR: par,
              CONSIGN: congin,
              SCAN: scan,
              AccountName: data,
              Account: `${data} (${par}/${congin}/${scan})`
            }
          }
        );
      });
      const sortAccountData = Object.keys(inventoryScan).sort().reduce(
        (account, key) => {
          account[key] = inventoryScan[key];
          return account;
        },
        {}
      );
      this.setState({
        account: sortAccountData
      });
      setLoader(false);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onScanSessionListBack = () => {
    try {
      this.setState({ isSessionList: false });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSelectedSession = (selectedScanSession) => {
    try {
      const { isSessionList } = this.state;
      if (selectedScanSession.sessionId !== '') {
        this.setState({
          selectedScanSession, isSessionList: !isSessionList
        });
      } else {
        this.setState({
          selectedScanSession: '', isSessionList: !isSessionList
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onChangeAccount = async (accountName) => {
    try {
      const { setInventoryFilter, inventoryFilter } = this.props;
      setInventoryFilter({
        ...inventoryFilter, AccountName: [accountName]
      });
      if (accountName !== undefined) {
        if (accountName.length > 0) {
          const getInventoryByAccountNameRes
            = await getInventoryByAccountName(accountName);
          const scanSessionRes = getInventoryByAccountNameRes.reduce((session, value) => {
            const key = value.SessionID;
            if (session[key] == null) session[key] = [];
            session[key].push({
              SessionName: value.SessionName,
              SessionID: value.SessionID,
              id: value.inventoryId
            });
            return session;
          }, {});
          const uniqueValue = {};
          Object.keys(scanSessionRes).map((key) => {
            Object.assign(uniqueValue, {
              [key]: [...new Map(scanSessionRes[key]
                .map((item) => [item.SessionID, item])).values()]
            });
          });
          this.setState({ scanSessionData: uniqueValue });
        }
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSelectedSessionData = (selectedSession) => {
    try {
      this.setState({ selectedSession }, () => {
        this._getOrderBy();
      });
      const { setInventoryFilter, inventoryFilter } = this.props;
      setInventoryFilter({
        ...inventoryFilter, Sessions: selectedSession
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onRemoveSelectedSessions = () => {
    try {
      this.setState({ selectedSession: [] });
      const { setInventoryFilter, inventoryFilter } = this.props;
      setInventoryFilter({
        ...inventoryFilter, Sessions: []
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _removeSession = (selectedSession, index) => {
    try {
      selectedSession.splice(index, 1);
      this.setState({ selectedSession });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onRemoveSelectedAccount = () => {
    try {
      this.setState({ accountName: '', selectedSession: [] });
      const { setInventoryFilter, inventoryFilter } = this.props;
      setInventoryFilter({
        ...inventoryFilter, Sessions: []
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onChangeOrderBy = (value) => {
    try {
      const { setInventoryFilter, inventoryFilter } = this.props;
      if (value === 'product') {
        document.getElementById('product').click();
      } else if (value === 'scanOrderFL') {
        document.getElementById('scanOrderFL').click();
      } else if (value === 'scanOrderLF') {
        document.getElementById('scanOrderLF').click();
      }
      this.setState({ selectedOrderBy: value });
      setInventoryFilter({
        ...inventoryFilter, OrderBy: [value]
      });
      if (value !== 'product') {
        setInventoryFilter({
          ...inventoryFilter, OrderBy: [value]
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onRemoveSelectedOrderBy = () => {
    try {
      const { setInventoryFilter, inventoryFilter } = this.props;
      this.setState({ selectedOrderBy: 'PRODUCT #' });
      delete inventoryFilter.OrderBy;
      setInventoryFilter({ ...inventoryFilter, OrderBy: 'PRODUCT #' });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onRemoveSearchProduct = () => {
    try {
      const { setInventoryFilter, inventoryFilter } = this.props;
      this.setState({ searchProduct: '' });
      delete inventoryFilter.Product;
      setInventoryFilter({ ...inventoryFilter });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onRemoveSearchProductDesc = () => {
    try {
      const { setInventoryFilter, inventoryFilter } = this.props;
      this.setState({ searchProductDesc: '' });
      delete inventoryFilter.ProductDescription;
      setInventoryFilter({ ...inventoryFilter });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onRemoveSearchLotNo = () => {
    try {
      const { setInventoryFilter, inventoryFilter } = this.props;
      this.setState({ searchLotNo: '' });
      delete inventoryFilter.LotNo;
      setInventoryFilter({ ...inventoryFilter });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onChangeVariance = (value) => {
    try {
      const { setInventoryFilter, inventoryFilter } = this.props;
      if (value === 'none') {
        document.getElementById('none').click();
      } else if (value === 'product') {
        document.getElementById('product').click();
      } else if (value === 'lot') {
        document.getElementById('lot').click();
      }
      this.setState({ selectedVariance: value });
      if (value !== 'NONE') {
        setInventoryFilter({
          ...inventoryFilter, isChecked: ['checked'], Variance: [value]
        });
      } else {
        delete inventoryFilter.InventoryComparison;
        delete inventoryFilter.Variance;
        delete inventoryFilter.isChecked;
        setInventoryFilter({
          ...inventoryFilter
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onRemoveSelectedVariance = () => {
    try {
      const { setInventoryFilter, inventoryFilter } = this.props;
      this.setState({ selectedVariance: 'NONE' });
      delete inventoryFilter.InventoryComparison;
      delete inventoryFilter.Variance;
      delete inventoryFilter.isChecked;
      setInventoryFilter({
        ...inventoryFilter
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onChangeInventoryComparison = (value) => {
    try {
      const { setInventoryFilter, inventoryFilter } = this.props;
      this.setState({ selectedInventoryComparison: value });
      setInventoryFilter({
        ...inventoryFilter, InventoryComparison: [value]
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onRemoveSelectedInventoryComparison = () => {
    try {
      this.setState({ selectedInventoryComparison: '' });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onChangeProduct = (event) => {
    try {
      const { setInventoryFilter, inventoryFilter } = this.props;
      this.setState({ searchProduct: [event.target.value] });
      setInventoryFilter({
        ...inventoryFilter, Product: [event.target.value]
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onChangeProductDescription = (event) => {
    try {
      const { setInventoryFilter, inventoryFilter } = this.props;
      this.setState({ searchProductDesc: [event.target.value] });
      setInventoryFilter({
        ...inventoryFilter, ProductDescription: [event.target.value]
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onChangeLotNo = (event) => {
    try {
      const { setInventoryFilter, inventoryFilter } = this.props;
      this.setState({ searchLotNo: [event.target.value] });
      setInventoryFilter({
        ...inventoryFilter, LotNo: [event.target.value]
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onCheckHideVariantsOrNot = () => {
    const { isChecked } = this.state;
    const { setInventoryFilter, inventoryFilter } = this.props;
    this.setState({
      isChecked: !isChecked,
    });
    let msg = ' ';
    if (isChecked) {
      msg = 'notChecked';
    } else {
      msg = 'checked';
    }
    setInventoryFilter({
      ...inventoryFilter, isChecked: [msg]
    });
  }

  _onScanOnly = () => {
    try {
      const { isScanOnly } = this.state;
      const { setInventoryFilter, inventoryFilter } = this.props;
      this.setState({ isScanOnly: !isScanOnly }, () => { this._getOrderBy(); });
      let msg = ' ';
      if (isScanOnly) {
        delete inventoryFilter.isScanOnly;
        setInventoryFilter(inventoryFilter);
      } else {
        msg = 'SCAN';
        setInventoryFilter({
          ...inventoryFilter,
          isScanOnly: [msg]
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onAlertExpireDate = () => {
    try {
      const { isExpire, expiringDay, startDate } = this.state;
      const { setInventoryFilter, inventoryFilter } = this.props;
      this.setState({ isExpire: !isExpire });
      let msg = ' ';
      if (isExpire) {
        delete inventoryFilter.isExpire;
        delete inventoryFilter.ExpiringDay;
        delete inventoryFilter.ExpireDate;
        setInventoryFilter(inventoryFilter);
      } else {
        msg = 'expired';
        setInventoryFilter({
          ...inventoryFilter,
          isExpire: [msg],
          ExpiringDay: [expiringDay],
          ExpireDate: [moment(startDate).format('M/DD/YY')]
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getOrderBy = () => {
    const { inventoryFilter } = this.props;
    if (inventoryFilter.hasOwnProperty('isScanOnly')) {
      if (inventoryFilter.isScanOnly.includes('SCAN')) {
        this.setState({
          orderData: [{
            id: 0,
            value: 'PRODUCT #'
          },
          {
            id: 1,
            value: 'SCAN ORDER (first to last)'
          },
          {
            id: 2,
            value: 'SCAN ORDER (last to first)'
          }],
          selectedOrderBy: 'PRODUCT #'
        });
      } else {
        this.setState({
          orderData: [
            {
              id: 0,
              value: 'PRODUCT #'
            }
          ],
          selectedOrderBy: 'PRODUCT #'
        });
      }
    } else {
      this.setState({
        orderData: [
          {
            id: 0,
            value: 'PRODUCT #'
          }
        ],
        selectedOrderBy: 'PRODUCT #'
      });
    }
  }

  async UNSAFE_componentWillMount() {
    try {
      const { inventoryFilter, setLoader } = this.props;
      const {
        selectedInventoryComparison, selectedVariance, isChecked, isScanOnly, selectedOrderBy,
        isExpire
      } = this.state;

      for (const key in inventoryFilter) {
        const result = inventoryFilter[key].filter((e) => e);
        if (result.length === 0 || result === '' || result === []) {
          delete inventoryFilter[key];
        }
      }
      setLoader(true);
      await this._onGetAccountName();
      await this._getOrderBy();
      if (Object.keys(inventoryFilter).length > 0) {
        this.setState({
          accountName: inventoryFilter.AccountName !== undefined ? inventoryFilter.AccountName[0] : '',
          selectedSession: inventoryFilter.Sessions,
          isScanOnly: inventoryFilter.isScanOnly !== undefined
            ? inventoryFilter.isScanOnly.includes('SCAN') : isScanOnly,
          searchProduct: inventoryFilter.Product,
          searchProductDesc: inventoryFilter.ProductDescription,
          searchLotNo: inventoryFilter.LotNo,
          isExpire: inventoryFilter.isExpire !== undefined
            ? inventoryFilter.isExpire.includes('expired') : isExpire,
          expiringDay: inventoryFilter.ExpiringDay,
          startDate: inventoryFilter.hasOwnProperty('ExpiringDay')
            ? new Date(inventoryFilter.ExpireDate) : new Date(),
          selectedInventoryComparison: inventoryFilter.InventoryComparison !== undefined
            ? inventoryFilter.InventoryComparison
            : selectedInventoryComparison,
          isChecked: inventoryFilter.isChecked !== undefined
            ? inventoryFilter.isChecked.includes('checked')
            : isChecked
        });

        if (inventoryFilter.OrderBy !== undefined) {
          this.setState({
            selectedOrderBy: inventoryFilter.OrderBy !== undefined
              ? inventoryFilter.OrderBy
              : selectedOrderBy,
          });
        }
        if (inventoryFilter.InventoryComparison !== undefined) {
          this.setState({
            selectedVariance: inventoryFilter.Variance !== undefined
              ? inventoryFilter.Variance
              : selectedVariance,
          });
        }
      }
      setLoader(false);
      // Listen for input event on numInput.
      const number = document.getElementById('number');
      number.onkeydown = function (e) {
        if (!((e.keyCode > 95 && e.keyCode < 106)
          || (e.keyCode > 47 && e.keyCode < 58)
          || e.keyCode === 8)) {
          return false;
        }
      };
      $('select').select2({ minimumResultsForSearch: -1 });
      $('#accountName').select2({
        placeholder: 'Select Account'
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render() {
    const {
      startDate, expiringDay, account, accountName, scanSessionData, isSessionList, selectedSession,
      selectedOrderBy, selectedVariance, selectedInventoryComparison, searchProduct,
      varianceSettingsData, searchProductDesc, searchLotNo, inventoryComparisonData, isChecked,
      isScanOnly, isExpire, orderData
    } = this.state;
    return (
      <section className="list-section resizer-class">
        <Header
          actionButton={isSessionList
            ? { title: 'Done', onClick: this._onSelectedSession }
            : (accountName !== '' || (searchProduct !== undefined && searchProduct.length > 0)
              || (searchProductDesc !== undefined && searchProductDesc.length > 0)
              || (searchLotNo !== undefined && searchLotNo.length > 0)) || (selectedVariance !== 'NONE')
              || (isScanOnly === true) || (isExpire === true)
              ? { title: 'View', onClick: this._onApplyFilter }
              : { title: '' }}
          title={isSessionList ? 'Select Sessions' : 'View Inventory'}
          goBack={isSessionList ? this._onScanSessionListBack : this._goBack}
        />
        {
          isSessionList
            ? (
              <ViewInventoryScanSession
                onSelectedSession={this._onSelectedSessionData}
                scanSessionData={scanSessionData}
              />
            ) : (
              <section className="case-details-section">
                <div className="container">
                  <div className="row gx-2">
                    <div className="col-12 col-md-12">
                      <div className="case-data">
                        <label htmlFor="account">Account</label>
                        <div className="input-group flex-nowrap">
                          <Select2
                            className="form-control select-2-black rounded w-100"
                            id="accountName"
                            onChange={({ target: { value } }) => {
                              this.setState({ accountName: value },
                                () => { this._onChangeAccount(value); });
                            }}
                            data={Object.keys(account).map((key) => ({
                              id: key,
                              text: account[key].Account
                            }))}
                            value={accountName}
                          />
                          {
                            accountName !== ''
                            && (
                              <button
                                className="btn input-group-icon-button opacity-1"
                                type="button"
                                onClick={this._onRemoveSelectedAccount}
                              >
                                <i className="icon-right fas fa-trash" />
                              </button>
                            )
                          }
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-md-12">
                      <div className="case-data">
                        <label htmlFor="scan">Scan Session</label>
                        <div className="input-group flex-nowrap">
                          <Link
                            className={`btn btn-scan-session d-block w-100 rounded ${selectedSession !== undefined && selectedSession.length > 0
                              ? 'selected-session-truncate' : 'delete-selected-session'}`}
                            onClick={this._onGetScanSessionList}
                          >
                            {
                              selectedSession !== undefined && selectedSession.length > 0
                                ? selectedSession.join(',') : 'Select Scan Session(s)'
                            }
                            {/* Select Scan Session(s) */}
                          </Link>
                          {
                            selectedSession !== undefined && selectedSession.length > 0
                            && (
                              <button
                                className={`btn input-group-icon-button ${selectedSession !== '' ? 'opacity-1' : 'opacity-0'}`}
                                type="button"
                                onClick={this._onRemoveSelectedSessions}
                              >
                                <i className="icon-right fas fa-trash" />
                              </button>
                            )
                          }
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-md-12 day-filter-item">
                      <div className="case-data">
                        <label className="cursor-pointer mt-2">
                          <input
                            type="checkbox" id="onlyScan"
                            onClick={this._onScanOnly}
                            checked={isScanOnly}
                            readOnly
                          />
                          <span className="me-2" />
                          Show only scans
                        </label>
                      </div>
                    </div>
                    <div className="col-12 col-md-12">
                      <div className="case-data">
                        <label htmlFor="orderBy">Order By</label>
                        <div className="input-group flex-nowrap">
                          <Select2
                            className="form-control select-2-black rounded w-100"
                            onChange={({ target: { value } }) => {
                              this.setState({ selectedOrderBy: value },
                                () => {
                                  this._onChangeOrderBy(value);
                                });
                            }}
                            data={orderData.map((order) => (order.value))}
                            defaultValue={selectedOrderBy}
                          />
                          {
                            selectedOrderBy !== 'PRODUCT #'
                            && (
                              <button
                                className="btn input-group-icon-button opacity-1"
                                type="button"
                                onClick={this._onRemoveSelectedOrderBy}
                              >
                                <i className="icon-right fas fa-trash" />
                              </button>
                            )
                          }
                        </div>
                      </div>
                    </div>

                    <div className="col-12 col-md-12">
                      <div className="case-data">
                        <label htmlFor="product">Product #</label>
                        <div className="input-group flex-nowrap">
                          <input
                            className="form-control view-int-input" type="text"
                            name="product" defaultValue=""
                            value={searchProduct}
                            onChange={(e) => this._onChangeProduct(e)}
                            placeholder="Search Product #"
                          />
                          {
                            searchProduct !== undefined && searchProduct.length > 0
                            && (
                              <button
                                className="btn input-group-icon-button opacity-1"
                                type="button"
                                onClick={this._onRemoveSearchProduct}
                              >
                                <i className="icon-right fas fa-trash" />
                              </button>
                            )
                          }
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-md-12">
                      <div className="case-data">
                        <label htmlFor="description">Product Description #</label>
                        <div className="input-group flex-nowrap">
                          <input
                            className="form-control view-int-input" type="text"
                            id="productDescription" name="productDescription"
                            defaultValue=""
                            value={searchProductDesc}
                            onChange={(e) => this._onChangeProductDescription(e)}
                            placeholder="Search Product Description #"
                          />
                          {
                            searchProductDesc !== undefined && searchProductDesc.length > 0
                            && (
                              <button
                                className="btn input-group-icon-button opacity-1"
                                type="button"
                                onClick={this._onRemoveSearchProductDesc}
                              >
                                <i className="icon-right fas fa-trash" />
                              </button>
                            )
                          }
                        </div>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="case-data">
                        <label htmlFor="lot">Lot #</label>
                        <div className="input-group flex-nowrap">
                          <input
                            className="form-control view-int-input" type="text"
                            id="lot" name="lot"
                            defaultValue=""
                            value={searchLotNo}
                            onChange={(e) => this._onChangeLotNo(e)}
                            placeholder="Search Lot #"
                          />
                          {
                            searchLotNo !== undefined && searchLotNo.length > 0
                            && (
                              <button
                                className="btn input-group-icon-button opacity-1"
                                type="button"
                                onClick={this._onRemoveSearchLotNo}
                              >
                                <i className="icon-right fas fa-trash" />
                              </button>
                            )
                          }
                        </div>
                      </div>
                    </div>
                    <div className="col-4 col-md-2">
                      <div className="case-data">
                        <label className="cursor-pointer mt-3">
                          <input
                            type="checkbox" id="alertExpire"
                            name="alertExpire"
                            onClick={this._onAlertExpireDate}
                            checked={isExpire}
                          />
                          <span className="me-2" />
                          Expiring in
                        </label>
                      </div>
                    </div>
                    <div className="col-8">
                      <div className="case-data row g-2">
                        <div className="col-6 col-md-auto">
                          <input
                            min="0"
                            className="form-control d-inline-block text-center view-int-input expire-days-truncate"
                            style={{ width: '55px' }}
                            type="number" id="number"
                            onChange={(e) => {
                              if (e.target.value.length === 7) return false;
                              this.setState({
                                expiringDay: e.target.value,
                              }, () => {
                                this._onChangeDay(e);
                              });
                            }}
                            value={expiringDay}
                            onBlur={() => {
                              this.setState({
                                expiringDay: expiringDay === '' ? 0 : expiringDay,
                              });
                            }}
                            onWheel={(event) => event.currentTarget.blur()}
                          />
                          <label
                            htmlFor="days" style={{ marginLeft: '3px', marginRight: '3px' }}
                          > days on
                          </label>
                        </div>

                        <div className="col-6">
                          <div className="d-inline-block">
                            <OptimizeDatePicker
                              dateFormat="MM/dd/yyyy"
                              id="expireDate"
                              style={{ maxWidth: '50px' }}
                              className="case-data view-int-input form-control react-datepicker-popper"
                              placeholderText="Start Date"
                              selected={startDate}
                              onChangeRaw={(e) => {
                                e.preventDefault();
                              }}
                              minDate={new Date()}
                              showDisabledMonthNavigation
                              onChange={(value) => {
                                this._onChangeDate(value);
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr className="line-height" />
                    <div className="col-12 col-md-12">
                      <p>Variance Settings</p>
                    </div>
                    <div className="col-12 col-md-12">
                      <div className="case-data">
                        <label htmlFor="productLot">Product or Lot</label>
                        <div className="input-group flex-nowrap">
                          <Select2
                            className="form-control select-2-black rounded w-100"
                            onChange={({ target: { value } }) => {
                              this.setState({ selectedVariance: value },
                                () => { this._onChangeVariance(value); });
                            }}
                            data={varianceSettingsData.map((variance) => (variance.value))}
                            defaultValue={selectedVariance}
                          />
                          {
                            selectedVariance !== 'NONE'
                            && (
                              <button
                                className={`btn input-group-icon-button ${selectedVariance !== '' ? 'opacity-1' : 'opacity-0'}`}
                                type="button"
                                onClick={this._onRemoveSelectedVariance}
                              >
                                <i className="icon-right fas fa-trash" />
                              </button>
                            )
                          }
                        </div>
                      </div>
                    </div>
                    {
                      selectedVariance !== 'NONE'
                      && (
                        <div className="col-12 col-md-12">
                          <div className="case-data">
                            <label htmlFor="comparison">Inventory Comparison</label>
                            <div className="input-group flex-nowrap">
                              <Select2
                                className="form-control select-2-black rounded w-100"
                                data={inventoryComparisonData.map(
                                  (compData) => (compData.value)
                                )}
                                onChange={({ target: { value } }) => {
                                  this._onChangeInventoryComparison(value);
                                }}
                                value={selectedInventoryComparison}
                              />
                              <button
                                className="btn input-group-icon-button opacity-1"
                                type="button"
                                onClick={this._onRemoveSelectedVariance}
                              >
                                <i className="icon-right fas fa-trash" />
                              </button>
                            </div>
                          </div>
                        </div>
                      )
                    }
                    {
                      selectedVariance !== 'NONE'
                      && (
                        <div className="col-12 col-md-12 day-filter-item">
                          <div className="case-data">
                            <label className="cursor-pointer mt-2">
                              <input
                                type="checkbox"
                                id="hide"
                                name="hide"
                                value="hide"
                                onChange={this._onCheckHideVariantsOrNot}
                                defaultChecked={isChecked}
                              />
                              <span className="me-2" />
                              Hide 0 Variance
                            </label>
                          </div>
                        </div>
                      )
                    }
                  </div>
                </div>
              </section>
            )
        }
        <NoScanSession />
      </section>
    );
  }
}

export default withInventoryFilter(
  withUser(
    withGoBack(
      withNotify(
        withLoader(
          ViewInventory
        )
      )
    )
  )
);
